// Ready vs Off-Plan from the listing's handover_date (31 Oct 2026).
// `status` is "active" for every listing, so `status === "ready"` labelled ALL 71 listings
// "Off-Plan" — including Bay Views, which is handed over (rule: never call it off-plan).
// "Ready" ONLY when the data says handed over / ready / completed. A planned date that has
// passed is NOT proof of completion (handovers slip) → show the stated date instead.
// Returns "Ready", "Off-Plan", "Handover <date>", or null (unknown → no badge, never guess).
export function readiness(p) {
  if (!p) return null;
  if (p.status === "ready") return "Ready";
  const raw = String(p.handover_date || "").trim();
  const h = raw.toLowerCase();
  if (!h) return null;
  if (/handed over|ready now|^ready|completed|complete\b/.test(h)) return "Ready";
  if (/under construction/.test(h)) return "Off-Plan"; // verified still being built (31 Oct 2026 research)
  const now = new Date();
  let end = null;
  const q = h.match(/q([1-4])\s*(\d{4})/);
  const half = h.match(/h([12])\s*(\d{4})/);
  const y = h.match(/(20\d{2})/);
  if (q) end = new Date(Number(q[2]), Number(q[1]) * 3, 0);
  else if (half) end = new Date(Number(half[2]), Number(half[1]) * 6, 0);
  else if (y) end = new Date(Number(y[1]), 11, 31);
  if (!end) return null;
  return end > now ? "Off-Plan" : `Handover ${raw}`;
}

// Ready, or a planned handover date that has already passed (not confirmed — the badge says which).
export function isReadyish(label) { return label === "Ready" || (typeof label === "string" && label.startsWith("Handover ")); }
